var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5954 2.87695C3.3488 3.1274 3.2666 3.37785 3.2666 3.96223V21.1598C3.2666 21.5772 3.3488 21.9946 3.6776 22.245L3.75979 22.3285L13.2949 12.728V12.6445L3.5954 2.87695Z",
    fill: "url(#paint0_linear_8915_120545)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2554 15.8281L13.1318 12.6557V12.4888L16.2554 9.31641L16.3376 9.39989L20.1187 11.5704C21.1873 12.2383 21.1873 13.1566 20.1187 13.8245L16.2554 15.8281Z",
    fill: "url(#paint1_linear_8915_120545)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4187 15.7344L13.213 12.4785L3.5957 22.1626C4.0067 22.58 4.58209 22.58 5.23968 22.246L16.4187 15.7344Z",
    fill: "url(#paint2_linear_8915_120545)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4199 9.22427L5.15862 2.71258C4.41883 2.37865 3.84344 2.46213 3.51465 2.79606L13.2141 12.4801L16.4199 9.22427Z",
    fill: "url(#paint3_linear_8915_120545)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8915_120545",
    x1: 3.23553,
    y1: 12.5653,
    x2: 13.2057,
    y2: 12.5653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8915_120545",
    x1: 13.1229,
    y1: 12.5766,
    x2: 20.9082,
    y2: 12.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8915_120545",
    x1: 3.53504,
    y1: 17.4879,
    x2: 16.3439,
    y2: 17.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E02553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8915_120545",
    x1: 3.53618,
    y1: 7.50201,
    x2: 16.3451,
    y2: 7.50201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.0720f0c8fd561ea7295b6a00a435d53c.svg";
export { ForwardRef as ReactComponent };